import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxPushDataToGTM } from './Pushdatatogtm'

interface PushdatatogtmBlokProps {
  blok: {
    title?: ''
  } & SbBlokData
}

const PushDataToGTM: FC<PushdatatogtmBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxPushDataToGTM />
    </div>
  )
}

export default PushDataToGTM
